import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { IBranchYearJudgeDTO } from './branch.year.judge.dto';
import { BranchYearRoundDTO, IBranchYearRoundDTO } from './branch.year.round.dto';
import { ISubmissionDTO, SubmissionDTO } from './submission.dto';

export interface IBranchYearJudgeRoundDTO extends IBaseEntityDTO {
  judgeAssignment: IBranchYearJudgeDTO[];
  round: IBranchYearRoundDTO;
  submissions: ISubmissionDTO[];
}

export class BranchYearJudgeRoundDTO extends BaseEntityDTO implements IBranchYearJudgeRoundDTO {
  judgeAssignment: IBranchYearJudgeDTO[];
  round: IBranchYearRoundDTO;
  submissions: ISubmissionDTO[];
  constructor(data?: Partial<BranchYearJudgeRoundDTO>) {
    super(data);
    this.judgeAssignment = [];
    this.round = new BranchYearRoundDTO(data?.round);
    this.submissions = data?.submissions
      ? data.submissions.map((submission) => new SubmissionDTO(submission))
      : [];
  }
}
